<template>
  <CommonEmployeeDetailsModal title="Manage Away Type">
    <CompanyAwayDetailEditForm
      :is-busy="isBusy"
      :form-set="selectedAway"
      @handle-submit="handleSubmit"
    ></CompanyAwayDetailEditForm>
  </CommonEmployeeDetailsModal>
</template>

<script>
import CommonEmployeeDetailsModal from "@/modules/company/components/shared/employee/modal/CommonEmployeeDetailsModal";
import CompanyAwayDetailEditForm from "@/modules/company/components/away/detail/CompanyAwayDetailEditForm";
export default {
  name: "CompanyAwayDetailModal",
  components: { CompanyAwayDetailEditForm, CommonEmployeeDetailsModal },
  props: {
    title: {
      String,
    },
    selectedAway: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isBusy: false,
    };
  },
  mounted() {
    console.log("Mounted", this.selectedAway);
  },
  methods: {
    /**
     *
     * @param form
     */
    handleSubmit(form) {
      console.log(form);

      const payload = {
        ...form,
        id: this.selectedAway.id,
      };

      this.isBusy = true;
      this.$store
        .dispatch("updateCompanyAwayDetails", payload)
        .then((res) => {
          console.log(res);
          this.$bvModal.msgBoxOk("Update Success");
        })
        .finally(() => {
          this.isBusy = false;
          this.$emit("detail-updated");
        });
    },
  },
};
</script>

<style scoped></style>
